/*global ViewController, WebView, moment, Mustache*/

var biController = new ViewController({
    directory : "views/bi",
    name: "bi",
    route: "bi"
}) ;

biController.prepareDataOnEnter = function(data, callback){
    //Get bis from modules (defined in registerModule)
    var bis = [] ;
    window.APP_MODULES.forEach(function(module){
        if(module.bis){
            bis = bis.concat(module.bis.sort(function(d1, d2){
                return (d1.position||0) - (d2.position||0);
            })) ;
        }
    }) ;

    data = {} ;

    data.bis = bis ;

    callback(null, data) ;
} ;


biController.onSelectedBi = function(){
    this.view.updateData() ;
    if(this.data.selectedBi){
        var bi = this.data.bis[this.data.selectedBi] ;

        var columns = bi.columns ;
        if(!columns){
            var schema = WebView.fieldsSchema.getSchema();
            columns = schema[bi.table].columns.map(function(col){
                return {
                    label: WebView.tr("fields."+bi.table+"."+col.name),
                    name: col.name,
                    type: col.type
                } ;
            }) ;
        }

        var tableHTML = '<table data-no-toolbar data-sidebar>' ;
        tableHTML += columns.map(function(colDef){
            return '<th data-field-name="'+colDef.name+
                '" data-field-type="'+colDef.type+
                '" data-field-defname="'+bi.table+"."+colDef.name+
                '"><label>'+colDef.label+'</label></th>' ;
        }).join("") ;
        tableHTML += '</table>' ;

        this.view.EL.grid.innerHTML = tableHTML ;
        this.view.EL.grid.setAttribute("data-field", "grid") ;
        this.view.longTask(function(done){
        this.view.createFieldFromElement(this.view.EL.grid, function(err){
            if(err){ return done(err) ;}
            this.api.db[bi.table].search(bi.search, function(err, results){
                if(err){ return done(err) ;}
                    this.view.EL.grid.setValue(results) ;
                    done() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }
} ;

module.exports = biController ;